export default __webpack_public_path__ + "static/20251128-a4601d955283311d8e784d47b438cb09.png";